import React, { useEffect, useState } from 'react';

// import qs from "qs";
import BoxServe from '../../../ajax/api/index';
import './DeviceHome.scss';
import { DownloadOutlined, ExclamationCircleFilled } from '@ant-design/icons';
import { Button, Table, Space, message, Select, Tag, Tooltip, ConfigProvider, Divider, Dropdown, Checkbox, Modal } from 'antd';

import copy from 'copy-to-clipboard';
// import { timeDifference } from "../../../utils/index";
import MonitorModel from './MonitorModel'; // 监控
import BusinessSwitchingModel from './BusinessSwitchingModel'; // 业务切换
import PressureMeasurementModel from './PressureMeasurementModel'; // 压测
import RemoteSettingsModel from './components/RemoteSettingsModel';
import StrategyModel from './StrategyModel'; // 设置盒子设备限速策略
import UpdateBoxInfoModel from './UpdateBoxInfoModel';
import ShellModel from './ShellModel'; // shell
import SearchHead from './components/SearchHead'; // 搜索区域
import LongShellModel from './components/LongShellModel';
import ShortShellModel from './components/ShortShellModel';
import { exportExcel } from '../../../utils/index';
import zh_CN from 'antd/es/locale/zh_CN';
const { confirm } = Modal;
const items = [
  {
    key: '1',
    label: '全部盒子',
    value: 'all'
  },
  {
    key: '2',
    label: '已选盒子',
    value: '1'
  },
  {
    key: '3',
    label: '符合查询条件盒子',
    value: '2'
  },
  {
    key: '4',
    label: '未来注册的所有设备',
    value: '3'
  },
  {
    key: '5',
    label: '输入设备号',
    value: '4'
  }
];

// table 操作项
const actionBtns = [
  {
    key: 'monitor',
    label: '监控',
    danger: false
  },
  {
    key: 'remoteSettings',
    label: '启用远程设置',
    danger: false
  },
  {
    key: 'business',
    label: '业务切换',
    danger: false
  },
  {
    key: 'shell',
    label: 'shell',
    danger: false
  },
  {
    key: 'pressureMeasurementSingle',
    label: '压测',
    danger: false
  },
  {
    key: 'editDeviceTag',
    label: '修改设备标记',
    danger: false
  }
];

// table 展示项
const tableShowOptions = [
  {
    value: 'deviceNo',
    label: '设备号'
  },
  {
    value: 'machineNo',
    label: '上游设备号'
  },
  // {
  //   value: "boxId",
  //   label: "上游BoxId",
  // },
  {
    value: 'onlineState',
    label: '状态'
  },
  {
    value: 'profitMoney',
    label: '昨日收益(元)'
  },
  {
    value: 'natType',
    label: '网络类型'
  },
  {
    value: 'openIp6',
    label: 'IPV6'
  },
  {
    value: 'tag',
    label: '设备标记'
  },
  {
    value: 'city',
    label: '设备所在地'
  },
  {
    value: 'runBusiness',
    label: '运行业务'
  },
  {
    value: 'askBusiness',
    label: '指定业务'
  },
  {
    value: 'askBusinessTime',
    label: '指定业务时间'
  },
  {
    value: 'isp',
    label: '网络运营商'
  },
  {
    value: 'physicalMem',
    label: '内存'
  },
  {
    value: 'diskInfo',
    label: '存储'
  },

  {
    value: 'pressBandwidth',
    label: '压测带宽'
  },
  {
    value: 'newCoreNum',
    label: 'CPU'
  },
  {
    value: 'moneyReason',
    label: '检查原因'
  },
  {
    value: 'createTime',
    label: '操作时间'
  }
];
// table 展示项默认选中
const tableShowDefaultValue = [
  'deviceNo',
  'machineNo',
  // "boxId",
  'onlineState',
  'profitMoney',
  'tag',
  'city',
  'runBusiness',
  'askBusiness',
  'askBusinessTime',
  'isp',
  'physicalMem',
  'diskInfo',
  'natType',
  'newCoreNum',
  'pressBandwidth',
  'createTime',
  'openIp6',
  'moneyReason'
];

const limitStrategyOptions = {
  1: '无限制',
  2: '固定限速',
  3: '智能限速'
};

export default function DeviceHome() {
  const role = localStorage.getItem('role');

  const columns = [
    {
      title: '设备号',
      key: 'deviceNo',
      dataIndex: 'deviceNo',
      fixed: 'left',
      width: 200,
      render: (_, record) => (
        <Space size="middle">
          <Tooltip overlayStyle={{ maxWidth: '60%' }} title={record?.deviceNo} color={'blue'} key={'blue'}>
            <span style={{ maxWidth: '160px', display: 'inline-block', wordBreak: 'break-all' }}>{record?.deviceNo}</span>
          </Tooltip>
          <span className="text-copy" onClick={() => handleCopy('deviceNo', record)}>
            {record?.deviceNo !== '' && String(record?.deviceNo) !== 'null' ? '复制' : ''}
          </span>
        </Space>
      )
    },
    {
      title: '上游设备号',
      key: 'machineNo',
      dataIndex: 'machineNo',
      width: 300,
      render: (_, record) => (
        <Space size="middle">
          <Tooltip overlayStyle={{ maxWidth: '60%' }} title={record?.machineNo} color={'blue'} key={'blue'}>
            <span style={{ maxWidth: '160px', display: 'inline-block', wordBreak: 'break-all' }}>{record?.machineNo}</span>
          </Tooltip>
          <span className="text-copy" onClick={() => handleCopy('machineNo', record)}>
            {record?.machineNo !== '' && String(record?.machineNo) !== 'null' ? '复制' : ''}
          </span>
        </Space>
      )
    },
    // {
    //   title: "上游boxId",
    //   key: "boxId",
    //   dataIndex: "boxId",
    //   width: 300,
    // },
    {
      title: '在线状态',
      key: 'onlineState',
      dataIndex: 'onlineState',
      width: 90,
      render: (_, record) => (
        <Space size="middle">
          <Tooltip overlayStyle={{ maxWidth: '60%' }} title={record?.onlineTime || ''} color={'blue'} key={'blue'}>
            <Space size="middle">{record.onlineState === '离线' ? <Tag color="#f50">离线</Tag> : <Tag color="#87d068">在线</Tag>}</Space>
          </Tooltip>
        </Space>
      )
      // render: (_, record) => <Space size="middle">{record.onlineState === "离线" ? <Tag color="#f50">离线</Tag> : <Tag color="#87d068">在线</Tag>}</Space>,
    },
    {
      title: '上游在线状态',
      key: 'status',
      dataIndex: 'status',
      width: 120,
      render: (_, record) => (
        <Space size="middle">
          <Space size="middle">
            <Space size="middle">{record?.upnodeInfoVo?.status === '离线' ? <Tag color="#f50">离线</Tag> : <Tag color="#87d068">在线</Tag>}</Space>
          </Space>
        </Space>
      )
    },
    {
      title: '昨日收益(元)',
      key: 'profitMoney',
      dataIndex: 'profitMoney',
      width: 120,
      render: (_, record) => (
        <Space size="middle">
          <span style={{ color: '#faad14' }}>{record.profitMoney}</span>
        </Space>
      )
    },
    {
      title: '网络类型',
      key: 'natType',
      dataIndex: 'natType',
      width: 130,
      render: (_, record) => (
        <Space size="middle">
          <Tooltip overlayStyle={{ maxWidth: '60%' }} title={() => setTitle(record)} color={'blue'} key={'blue'}>
            <span>{record?.natType}</span>
          </Tooltip>
          <span className="text-copy" onClick={() => handleCopy('natType', record)}>
            {record?.natType !== '' && String(record?.natType) !== 'null' ? '复制' : ''}
          </span>
        </Space>
      )
    },
    {
      title: '上游nat类型',
      key: 'natType',
      dataIndex: 'natType',
      width: 130,
      render: (_, record) => (
        <Space size="middle">
          <span>{record?.upnodeInfoVo?.natType || ''}</span>
        </Space>
      )
    },
    {
      title: 'IPV6',
      key: 'openIp6',
      dataIndex: 'openIp6',
      width: 80,
      render: (_, record) => <Space size="middle">{record.openIp6 === '0' ? <Tag color="#f50">未开启</Tag> : <Tag color="#87d068">已开启</Tag>}</Space>
    },
    {
      title: '设备标记',
      key: 'tag',
      dataIndex: 'tag',
      width: 200
    },
    {
      title: '设备所在地',
      key: 'city',
      dataIndex: 'city',
      width: 150
    },
    {
      title: '运行业务',
      key: 'runBusiness',
      dataIndex: 'runBusiness',
      width: 100
    },
    {
      title: '指定业务',
      key: 'askBusiness',
      dataIndex: 'askBusiness',
      width: 100,
      render: (_, record) => (
        <Space size="middle">
          {record?.upnodeInfoVo?.faultInfo ? (
            <Tooltip overlayStyle={{ maxWidth: '60%' }} title={record?.upnodeInfoVo?.faultInfo || ''} color={'blue'} key={'blue'}>
              <span style={{ color: '#f50' }}>{record.askBusiness}</span>
            </Tooltip>
          ) : (
            <span style={{ color: '#87d068' }}>{record.askBusiness}</span>
          )}
          {/* <span>{record?.upnodeInfoVo?.faultInfo ? <span style={{ color: "#f50" }}>{record.askBusiness}</span> : <span style={{ color: "#87d068" }}>{record.askBusiness}</span>}</span> */}
        </Space>
      )
    },
    {
      title: '指定业务时间',
      key: 'askBusinessTime',
      dataIndex: 'askBusinessTime',
      width: 180
    },
    {
      title: '网络运营商',
      key: 'isp',
      dataIndex: 'isp',
      width: 120
    },
    {
      title: '内存',
      key: 'physicalMem',
      dataIndex: 'physicalMem',
      width: 160
    },
    {
      title: '存储',
      key: 'diskInfo',
      dataIndex: 'diskInfo',
      width: 120
    },

    {
      title: 'CPU',
      key: 'newCoreNum',
      dataIndex: 'coreNum',
      width: 130,
      render: (_, record) => (
        <Space size="middle">
          <Tooltip overlayStyle={{ maxWidth: '60%' }} title={() => setCPUTitle(record)} color={'blue'} key={'blue'}>
            <span>
              {record?.coreNum}-{record?.cpu?.frequency}
            </span>
          </Tooltip>
          <span className="text-copy" onClick={() => handleCopy('coreNum', record)}>
            {record?.coreNum !== '' && String(record?.coreNum) !== 'null' ? '复制' : ''}
          </span>
        </Space>
      )
    },
    {
      title: '压测带宽',
      key: 'pressBandwidth',
      dataIndex: 'pressBandwidth',
      width: 130,
      render: (_, record) => (
        <Space size="middle">
          <span style={{ color: '#faad14' }}>{record.upnodeInfoVo?.pressBandwidth || '-'}</span>
        </Space>
      )
    },
    {
      title: '限速策略',
      key: 'limitStrategy',
      dataIndex: 'limitStrategy',
      width: 130,
      render: (_, record) => (
        <Space size="middle">
          <span style={{ color: '#faad14' }}>
            {record.limitStrategy
              ? String(record.limitStrategy) === '2'
                ? `${limitStrategyOptions[record.limitStrategy]}-${record.limitBandwidth}`
                : limitStrategyOptions[record.limitStrategy]
              : '-' || '-'}
          </span>
        </Space>
      )
    },
    {
      title: '激活时间',
      key: 'createTime',
      dataIndex: 'createTime',
      width: 130
    },
    {
      title: '再上线时间',
      key: 'onlineAgainTime',
      dataIndex: 'onlineAgainTime',
      width: 130
    },
    {
      title: '检查原因',
      key: 'moneyReason',
      dataIndex: 'moneyReason',
      width: 130
    },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      fixed: 'right',
      width: 130,
      render: (_, record) => (
        <>
          <Dropdown
            trigger="click"
            menu={{
              items: role === 'root' ? actionBtns : actionBtns?.slice(0, 2),
              onClick: (e) => handleActionChange(e, record)
            }}
          >
            <Button type="primary">选择操作</Button>
          </Dropdown>
        </>
      )
    }
  ];

  let [tableColumns, setTableColumns] = useState([...columns]);

  // 提示信息
  const [messageApi, contextHolder] = message.useMessage();

  // 勾选选择
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  // 勾选选择的deviceNo集合
  const [deviceNoList, setDeviceNoList] = useState([]);

  // 长期、短期命令选择（全部、已选盒子）
  const [shellList, setShellList] = useState([]);

  // 监控弹框
  const [dataObj, setDataObj] = useState({
    monitorVisible: false,
    deviceId: '',
    deviceNo: ''
  });

  // shell 弹框
  const [isShell, setIsShell] = useState(false);

  // 业务切换弹框
  const [businessSwitching, setBusinessSwitchingModel] = useState(false);

  // 压测
  const [pressureMeasurement, setPressureMeasurement] = useState(false);

  const [updateBoxInfoModel, setUpdateBoxInfoModel] = useState(false);

  // 启用远程设置
  const [remoteSettingsModel, setRemoteSettingsModel] = useState(false);

  // 设置盒子设备限速策略
  const [strategyModel, setStrategyModel] = useState(false);

  // 短期命令弹框
  const [isShortShellModel, setIsShortShellModel] = useState(false);

  // 长期命令弹框
  const [isLongShellModel, setIsLongShellModel] = useState(false);

  // 短期任务命令选择
  const [selectShortVal, setSelectShortVal] = useState('');
  // 长期任务命令选择
  const [selectLongVal, setSelectLongVal] = useState('');

  const [searchParams, setSearchParams] = useState({});

  // 当前选中项
  const [itemChecked, setItemChecked] = useState({});

  // 选中id
  const [activeId, setActiveId] = useState(null);

  let [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);

  const [tableParams, setTableParams] = useState({
    page: 1,
    limit: 20,
    current: 1,
    defaultPageSize: 20
  });

  const [params] = useState({
    page: tableParams.page,
    current: tableParams.page,
    limit: tableParams.limit
  });

  // 总条数
  const [total, setTotal] = useState(0);

  // 操作命令
  const [operationCommand, setOperationCommand] = useState([]);

  // 操作命令--选中当前项
  const [selectedValue, setSelectedValue] = useState(null);

  // 勾选选择
  const onSelectChange = (newSelectedRowKeys, filters) => {
    console.log(newSelectedRowKeys);
    const list = filters?.map((item) => item.deviceNo);
    setDeviceNoList(list);
    setSelectedRowKeys(newSelectedRowKeys);
  };

  // 勾选选择
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange
  };

  // 设置网络类型显示内容
  const setTitle = (item) => {
    return (
      <>
        <div className="tooltip-wrap">
          <div className="li">
            <label className="title">natType:</label>
            <span className="contents">{item.natType}</span>
          </div>
          <div className="li">
            <label className="title">mac:</label>
            <span className="contents">{item?.netAddr.mac}</span>
          </div>
          <div className="li">
            <label className="title">ipv4:</label>
            <span className="contents">
              {item?.netAddr?.ipv4?.map((item, index) => (
                <p key={index}>{item}</p>
              ))}
            </span>
          </div>
          <div className="li">
            <label className="title">ipv6:</label>
            <span className="contents">
              {item?.netAddr?.ipv6?.map((item, index) => (
                <p key={index}>{item}</p>
              ))}
            </span>
          </div>
        </div>
      </>
    );
  };

  // 设置CPU显示内容
  const setCPUTitle = (item) => {
    return (
      <>
        <div className="tooltip-wrap">
          <div className="li">
            <label className="title">modelName:</label>
            <span className="contents">{item?.cpu?.modelName}</span>
          </div>
          <div className="li">
            <label className="title">vendorId:</label>
            <span className="contents">{item?.cpu?.vendorId}</span>
          </div>
          <div className="li">
            <label className="title">coreNum:</label>
            <span className="contents">{item?.coreNum}</span>
          </div>
          <div className="li">
            <label className="title">frequency:</label>
            <span className="contents">{item?.cpu?.frequency}</span>
          </div>
        </div>
      </>
    );
  };

  // 复制
  const handleCopy = (modl, record) => {
    if (modl === 'natType') {
      const { natType, netAddr } = record;
      const contents =
        natType +
        ' ' +
        netAddr.mac +
        ' ' +
        netAddr?.ipv4?.map((item) => {
          return item + ' ';
        }) +
        netAddr?.ipv6?.map((item) => {
          return item + ' ';
        });
      if (copy(contents)) {
        messageApi.open({
          type: 'success',
          content: '复制成功！'
        });
      } else {
        messageApi.open({
          type: 'error',
          content: '复制失败！'
        });
      }
    } else if (modl === 'coreNum') {
      const { coreNum, cpu } = record;
      const contents = coreNum + ' ' + cpu?.modelName + ' ' + cpu?.frequency + ' ' + cpu?.vendorId;
      if (copy(contents)) {
        messageApi.open({
          type: 'success',
          content: '复制成功！'
        });
      } else {
        messageApi.open({
          type: 'error',
          content: '复制失败！'
        });
      }
    } else {
      const contents = record[modl];
      if (copy(contents)) {
        messageApi.open({
          type: 'success',
          content: '复制成功！'
        });
      } else {
        messageApi.open({
          type: 'error',
          content: '复制失败！'
        });
      }
    }
  };

  // 列表数据
  const getList = async (model) => {
    if (model === 'business') {
      // 点击切换，重置选中
      setSelectedRowKeys([]);
    }
    try {
      setLoading(true);
      const { code, data, count } = await BoxServe.boxdeviceList(tableParams).finally(() => {
        setLoading(false);
      });
      if (String(code) === '0') {
        // setTableParams({
        //   ...tableParams,
        //   total: count ? Number(count) : 0
        // });
        setTotal(count ? Number(count) : 0);
        const list = data?.map((item) => {
          const { mem, storage, cpu, net } = JSON.parse(item.content);
          const { mem: lastMem, storage: lastStorage } = item.lastContent ? JSON.parse(item.lastContent) : {};
          return {
            ...item,
            key: item.id,
            physicalMem: mem?.physicalMem || '',
            diskInfo: storage?.diskInfo?.[0] || '',
            coreNum: cpu?.coreNum || '',
            newCoreNum: 'coreNum:' + cpu?.coreNum + ' ' + 'frequency:' + cpu?.frequency + ' ' + 'modelName:' + cpu?.modelName + ' ' + 'vendorId:' + cpu?.vendorId,
            natType: net?.natType || '',
            netAddr: net?.netAddr || '',
            cpu,
            memTotal: lastMem?.total || 0,
            storageTotalSize: lastStorage?.[0].totalSize || 0
          };
        });

        setList(list);
      } else {
        messageApi.open({
          type: 'warning',
          content: '出错了~'
        });
      }
    } catch (error) {
      // message.error(error.message || error.msg)
      console.log(error);
    }
  };

  useEffect(() => {
    getList();
  }, [tableParams, params]);

  // 监控弹出框
  const handleMonitor = (record) => {
    console.log(record);
    const { id, deviceNo, coreNum, memTotal, storageTotalSize } = record;
    setActiveId(id);
    setDataObj({
      monitorVisible: true,
      deviceId: id,
      deviceNo,
      coreNum,
      memTotal,
      storageTotalSize
    });
  };

  // 分页等
  const onChange = (pagination) => {
    const { current, pageSize } = pagination;
    setList([]);
    setTableParams({
      ...searchParams,
      page: current,
      limit: pageSize
    });
  };

  // 监控弹框关闭
  const handleMonitorModelClose = () => {
    setDataObj({
      monitorVisible: false,
      deviceId: ''
    });
  };

  // 业务切换
  const handleBusinessSwitching = () => {
    if (selectedRowKeys?.length <= 0) {
      return message.warning('请选择数据');
    }
    setBusinessSwitchingModel(true);
  };

  // 压测
  const handlePressureMeasurement = () => {
    if (selectedRowKeys?.length <= 0) {
      return message.warning('请选择数据');
    }
    setPressureMeasurement(true);
  };

  // 压测--单个
  const handlePressureMeasurementSingle = (item) => {
    setActiveId(item.id);
    setDeviceNoList([item.deviceNo]);
    setPressureMeasurement(true);
  };

  // 压测弹框关闭
  const handlePressureMeasurementClose = () => {
    setPressureMeasurement(false);
  };

  //

  // 业务切换弹框关闭
  const handleBusinessSwitchinClose = () => {
    setBusinessSwitchingModel(false);
  };

  // 单选业务切换
  const handleBusiness = (item) => {
    setActiveId(item.id);
    setDeviceNoList([item.deviceNo]);
    setItemChecked(item);
    setBusinessSwitchingModel(true);
  };

  // shell 弹框
  const handleShell = (item) => {
    setActiveId(item.id);
    setDeviceNoList([item.deviceNo]);
    setIsShell(true);
  };

  // shell 弹框关闭
  const handleShellColse = () => {
    setIsShell(false);
  };

  // 长期命令弹框关闭
  const handleLongShellModelColse = () => {
    setIsLongShellModel(false);
    // setSelectLongVal("");
  };

  // 短期命令弹框关闭
  const handleShortShellModelColse = () => {
    setIsShortShellModel(false);
    // setSelectShortVal("");
  };

  // 短期命令弹框打开
  const handleShortShellModel = (e) => {
    if (selectShortVal === '') {
      return message.warning('请选择');
    }
    if (selectShortVal === '1' && selectedRowKeys?.length <= 0 && selectShortVal !== 'all') {
      return message.warning('请选择数据');
    } else if (selectShortVal === 'all' || selectShortVal === '2') {
      setShellList([]);
    } else {
      setShellList([...deviceNoList]);
    }

    setIsShortShellModel(true);
  };

  // 长期命令弹框打开
  const handleLongShellModel = (e) => {
    if (selectLongVal === '') {
      return message.warning('请选择');
    }
    if (selectLongVal === '1' && selectedRowKeys?.length <= 0 && selectLongVal !== 'all') {
      return message.warning('请选择数据');
    } else if (selectLongVal === 'all' || selectLongVal === '2' || selectLongVal === '3' || selectLongVal === '4') {
      setShellList([]);
    } else {
      setShellList([...deviceNoList]);
    }
    setIsLongShellModel(true);
  };

  // 长期任务命令选择
  const handleChangeLongSelect = (val) => {
    setSelectLongVal(val);
    setSelectedRowKeys([]);
    setShellList([]);
  };

  // 短期任务命令选择
  const handleChangeShortSelect = (val) => {
    setSelectShortVal(val);
    setSelectedRowKeys([]);
    setShellList([]);
  };

  // 搜索
  const handleSearch = (obj, mode) => {
    const newObj = { ...obj, deviceIds: obj?.deviceIds?.trim() };
    setSearchParams(newObj);
    setTableParams({
      ...tableParams,
      current: 1,
      ...newObj
    });

    // 重置
    if (mode === 'reset') {
      setActiveId(null);
    }
  };

  // 导出excel
  const handleExportExcel = () => {
    const name = `box_设备列表_${new Date().getTime()}`;
    const sheetHeader = [];
    const sheetFilter = [];
    const columnWidths = [];

    // const sheetHeader = ["设备号", "状态", "设备所在地", "运行业务"];
    // let sheetFilter = ["deviceNo", "onlineState", "city", "askBusiness"];
    columns?.forEach((item) => {
      let { title, dataIndex, key, width } = item;
      if (title !== '操作') {
        sheetHeader.push(title);
      }
      if (key === 'newCoreNum') {
        sheetFilter.push(key);
      } else {
        sheetFilter.push(dataIndex);
      }

      columnWidths.push(width / 10);
    });
    exportExcel(list, name, sheetHeader, sheetFilter, columnWidths);
  };

  // 点击操作选中当前行
  const rowClassName = (record, index) => {
    return record.id === activeId ? 'is-active-row' : '';
  };

  // 修改设备标记
  const handleEditDeviceTag = (item) => {
    setActiveId(item.id);
    setUpdateBoxInfoModel(true);
    setDeviceNoList([item.deviceNo]);
  };

  // 修改设备标记弹框关闭
  const handleupdateBoxInfoModelClose = () => {
    setUpdateBoxInfoModel(false);
  };

  // 启用远程设置
  const handleSettingsModelClose = () => {
    setRemoteSettingsModel(false);
  };

  const handleStrategyModelClose = () => {
    setStrategyModel(false);
  };

  // 批量修改设备标记
  const handleEditDeviceMark = () => {
    if (selectedRowKeys?.length <= 0) {
      return message.warning('请选择数据');
    }
    setUpdateBoxInfoModel(true);
  };

  // 设置盒子设备限速策略
  const handleStrategy = () => {
    if (selectedRowKeys?.length <= 0) {
      return message.warning('请选择数据');
    }
    setStrategyModel(true);
  };

  // 启用远程设置
  const handleRemoteSettings = (record) => {
    setActiveId(record.id);
    setRemoteSettingsModel(true);
    setItemChecked(record);
  };

  // 操作栏下拉列表
  const handleActionChange = (e, record) => {
    switch (e.key) {
      case 'monitor': // 监控
        handleMonitor(record);
        break;
      case 'business': // 业务切换
        handleBusiness(record);
        break;
      case 'shell': // shell
        handleShell(record);
        break;
      case 'pressureMeasurementSingle': // 压测
        handlePressureMeasurementSingle(record);
        break;
      case 'editDeviceTag': // 修改设备标记
        handleEditDeviceTag(record);
        break;
      case 'remoteSettings': // 启用远程设置
        handleRemoteSettings(record);
        break;
      default:
        console.log('没有默认');
    }
  };

  // 操心table展示项
  const handleTableChange = (checkedValue) => {
    const newList = columns?.filter((item) => checkedValue?.includes(item.key));
    setTableColumns(newList.concat(columns?.slice(-1)));
  };

  // 重置
  const handleReset = () => {
    setTableParams({
      page: 1,
      limit: 20,
      current: 1,
      defaultPageSize: 20
    });
  };

  // 操作命令列表
  const handleGetOperationCommand = async () => {
    try {
      const {
        code,
        msg,
        data = []
      } = await BoxServe.commandList({
        page: 1,
        limit: 20
      }).finally(() => {});
      if (String(code) === '0') {
        const list = data?.map((item) => {
          const { script = '', commandName = '' } = item;
          return {
            ...item,
            value: script,
            label: commandName
          };
        });
        setOperationCommand(list);
      } else {
        message.error('错误！');
      }
    } catch (error) {
      message.error(error.message || error.msg);
      console.log(error);
    }
  };

  // 操作命令选择
  const handleSelectOperationCommand = async (value) => {
    if (selectedRowKeys?.length <= 0) {
      return message.warning('请选择数据');
    }
    setSelectedValue(value);
    confirm({
      title: '是否执行该项命令？',
      icon: <ExclamationCircleFilled />,
      content: '',
      onOk() {
        executeCommand(value, 'commandSelection');
        // return new Promise((resolve, reject) => {
        //   // setTimeout(Math.random() > 0.5 ? resolve : reject, 1000);
        // }).catch(() => console.log("Oops errors!"));
      },
      onCancel() {
        setSelectedValue(null);
      }
    });
  };

  // 执行短期命令

  const executeCommand = async (command, mode) => {
    const params = {
      command,
      timeOut: 120,
      autoClose: 1,
      fastCommand: 0,
      remark: '',
      batchNo: mode === 'commandSelection' ? '' : deviceNoList?.join(','),
      query: {},
      queryFlag: '0',
      deviceNoList: deviceNoList?.join(',')
    };
    try {
      const { code, data, msg } = await BoxServe.sendBatchRemoteCmd(params);
      if (String(code) === '0') {
        message.success('命令发送成功！');
      } else {
        message.error(msg);
      }
    } catch (error) {
      message.error(error.message || error.msg);
      console.log(error);
    }
  };

  useEffect(() => {
    handleGetOperationCommand();
  }, []);

  return (
    <>
      {contextHolder}
      <div className="home-wrap">
        <div className="search-wrap">
          <SearchHead handleSearch={handleSearch} handleReset={handleReset} />
        </div>
        <div className="top">
          {role === 'root' ? (
            <div className="top-left">
              <span className="checked-text">已选择{selectedRowKeys.length || 0}台盒子</span>
              <Button type="primary" className="btn" danger onClick={handleBusinessSwitching}>
                业务切换
              </Button>
              <Button type="primary" className="btn" danger onClick={handlePressureMeasurement}>
                批量压测
              </Button>
              <Button type="primary" className="btn" danger onClick={handleEditDeviceMark}>
                批量修改标记
              </Button>
              <Button type="primary" className="btn" danger onClick={handleStrategy}>
                设备限速策略
              </Button>

              <Space.Compact className="shell-box">
                <Select defaultValue="" options={items.slice(0, 3)} onChange={handleChangeShortSelect} />
                <Button type="primary" onClick={handleShortShellModel}>
                  短期任务命令
                </Button>
              </Space.Compact>
              <Space.Compact className="shell-box">
                <Select defaultValue="" options={items} onChange={handleChangeLongSelect} style={{ width: 200 }} />
                <Button type="primary" onClick={handleLongShellModel}>
                  长期任务命令
                </Button>
              </Space.Compact>
              <Space wrap>
                <span className="operation-command">操作命令：</span>
                <Select defaultValue="" style={{ width: 150 }} value={selectedValue} options={operationCommand} onSelect={handleSelectOperationCommand} />
              </Space>
            </div>
          ) : (
            <div></div>
          )}
          <div className="top-right">
            <Space wrap className="operate-btn">
              <Select
                placeholder="请选择展示项"
                status="error"
                style={{
                  width: 200
                }}
                dropdownRender={() => (
                  <>
                    <Checkbox.Group className="select-checkbox" defaultValue={tableShowDefaultValue} options={tableShowOptions} onChange={handleTableChange} />
                  </>
                )}
              />
              <Button type="dashed" danger icon={<DownloadOutlined />} onClick={handleExportExcel}>
                导出Excel
              </Button>
            </Space>
          </div>
        </div>
        <ConfigProvider locale={zh_CN}>
          <Table
            id="table"
            scroll={{ x: '100%' }}
            filterMultiple
            rowSelection={rowSelection}
            columns={tableColumns}
            dataSource={list}
            loading={loading}
            rowClassName={rowClassName}
            pagination={{
              showSizeChanger: true,
              pageSizeOptions: [10, 20, 50, 100, 500, 1000, 5000, 10000],
              total,
              ...tableParams,
              showTotal: (total) => {
                return `共 ${total} 条`;
              }
            }}
            onChange={onChange}
            className="device-home"
          />
        </ConfigProvider>
        {/* 监控弹框 */}
        <MonitorModel dataObj={dataObj} handleMonitorModelClose={handleMonitorModelClose} />
        {/* 业务切换弹框 */}
        <BusinessSwitchingModel open={businessSwitching} item={itemChecked} list={deviceNoList} getBusinessList={getList} handleBusinessSwitchinClose={handleBusinessSwitchinClose} />
        {/* 压测 */}
        <PressureMeasurementModel open={pressureMeasurement} list={deviceNoList} getBusinessList={getList} handlePressureMeasurementClose={handlePressureMeasurementClose} />
        {/* 修改设备标记 */}
        <UpdateBoxInfoModel open={updateBoxInfoModel} list={deviceNoList} getBusinessList={getList} handleupdateBoxInfoModelClose={handleupdateBoxInfoModelClose} />

        {/* shel弹框 */}
        <ShellModel open={isShell} list={deviceNoList} handleShellColse={handleShellColse} />
        {/* 长期命令 */}
        <LongShellModel open={isLongShellModel} list={shellList} searchParams={searchParams} selectLongVal={selectLongVal} handleLongShellModelColse={handleLongShellModelColse} />
        {/* 短期命令 */}
        <ShortShellModel open={isShortShellModel} list={shellList} searchParams={searchParams} selectShortVal={selectShortVal} handleShortShellModelColse={handleShortShellModelColse} />

        {/*启用远程设置 */}
        <RemoteSettingsModel open={remoteSettingsModel} item={itemChecked} getBusinessList={getList} handleSettingsModelClose={handleSettingsModelClose} />
        {/* 设置盒子设备限速策略 */}
        <StrategyModel open={strategyModel} list={deviceNoList} getBusinessList={getList} handleStrategyModelClose={handleStrategyModelClose} />
      </div>
    </>
  );
}
